// Translations for V2 deployment steps

export const V2_STEP_TRANSLATIONS: Record<string, { name: string; description: string }> = {
  // Tenant creation (local step during initialization)
  create_tenant: {
    name: 'Création du tenant',
    description: 'Création du tenant sur l\'infrastructure V2',
  },

  // Host connectivity verification
  host_connectivity_verification: {
    name: 'Vérification de la connectivité',
    description: 'Vérification de la connexion au serveur hôte',
  },

  // Database creation
  database_creation: {
    name: 'Création de la base de données',
    description: 'Création de la base de données pour le tenant',
  },

  // Database user creation
  database_user_creation: {
    name: 'Création de l\'utilisateur BDD',
    description: 'Création de l\'utilisateur de base de données',
  },

  // Database migration
  database_migration: {
    name: 'Migration de la base de données',
    description: 'Exécution des migrations de schéma',
  },

  // Doctrine migrations
  doctrine_migrations: {
    name: 'Migrations Doctrine',
    description: 'Exécution des migrations pour configurer le schéma du tenant',
  },

  // Database schema validation
  database_schema_validation: {
    name: 'Validation du schéma',
    description: 'Vérification que le schéma de base de données est correctement configuré',
  },

  // Database seeding
  database_seeding: {
    name: 'Initialisation des données',
    description: 'Insertion des données initiales',
  },

  // School period initialization
  school_period_initialization: {
    name: 'Initialisation de la période scolaire',
    description: 'Création de l\'école et de la période scolaire initiale',
  },

  // Mail template initialization
  mail_template_initialization: {
    name: 'Initialisation des modèles d\'emails',
    description: 'Configuration des modèles d\'emails',
  },

  // Sync role permissions
  sync_role_permissions: {
    name: 'Synchronisation des permissions',
    description: 'Synchronisation des associations rôles-permissions depuis la configuration',
  },

  // Cache configuration
  cache_configuration: {
    name: 'Configuration du cache',
    description: 'Configuration du système de cache',
  },

  // Storage setup
  storage_setup: {
    name: 'Configuration du stockage',
    description: 'Préparation du système de stockage de fichiers',
  },

  // Admin user creation
  admin_user_creation: {
    name: 'Création de l\'administrateur',
    description: 'Création du compte administrateur initial',
  },

  // Configuration finalization
  configuration_finalization: {
    name: 'Finalisation',
    description: 'Finalisation de la configuration du tenant',
  },

  // DNS verification
  dns_verification: {
    name: 'Vérification DNS',
    description: 'Vérification de la configuration DNS',
  },

  // SSL certificate
  ssl_certificate: {
    name: 'Certificat SSL',
    description: 'Configuration du certificat SSL',
  },

  // Health check
  health_check: {
    name: 'Test de santé',
    description: 'Vérification du bon fonctionnement',
  },

  // Notification
  notification: {
    name: 'Notification',
    description: 'Envoi des notifications de création',
  },

  // Tenant configuration
  tenant_configuration: {
    name: 'Configuration du tenant',
    description: 'Configuration initiale du tenant',
  },

  // Default data seeding
  default_data_seeding: {
    name: 'Données par défaut',
    description: 'Insertion des données par défaut',
  },

  // Fixtures loading
  fixtures_loading: {
    name: 'Chargement des fixtures',
    description: 'Chargement des données de fixtures',
  },

  // Environment setup
  environment_setup: {
    name: 'Configuration de l\'environnement',
    description: 'Préparation de l\'environnement du tenant',
  },

  // Queue setup
  queue_setup: {
    name: 'Configuration des files d\'attente',
    description: 'Configuration du système de files d\'attente',
  },

  // Scheduler setup
  scheduler_setup: {
    name: 'Configuration du planificateur',
    description: 'Configuration des tâches planifiées',
  },

  // Initialize relation types
  initialize_relation_types: {
    name: 'Initialisation des types de relations',
    description: 'Configuration des types de relations entre rôles',
  },

  // Dynamic form data initialization
  dynamic_form_data_initialization: {
    name: 'Initialisation des formulaires dynamiques',
    description: 'Configuration des données de formulaires dynamiques',
  },
};

/**
 * Get translated step name and description
 * Falls back to original values if no translation exists
 */
export function getStepTranslation(
  stepId: string,
  originalName?: string,
  originalDescription?: string
): { name: string; description: string } {
  const translation = V2_STEP_TRANSLATIONS[stepId];

  if (translation) {
    return translation;
  }

  // Fallback: format the step ID as a readable name
  const formattedName = stepId
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

  return {
    name: originalName || formattedName,
    description: originalDescription || '',
  };
}
